<template>
    <div class="user-detail">
        <!-- BASIC INFO -->
        <div class="mb-4">
            <EditableRow :editable="editable" :body="user.first_name" @body="(newValue) => {user.first_name = newValue}" :header="$t('user.firstName')" />
            <EditableRow :editable="editable" :body="user.last_name" @body="(newValue) => {user.last_name = newValue}" :header="$t('user.lastName')" />
            <EditableRow v-if="editable" :editable="editable" :body="user.password" @body="(newValue) => {user.password = newValue}" :header="$t('user.password')" />
        </div>

        <!-- FUNCTIONS -->
        <div class="mb-4">
            <p class=" mb-2">
                {{ $t("user.functions") }}
            </p>
            <!-- EDIT MODE -->
            <div v-if="editable">
                <select multiple v-model="user.functions" class="form-select">
                    <option v-for="(func, i) in functions" :key="i" :value="func">
                        {{ $t("functions." + func.name) }}
                    </option>
                </select>
            </div>
            <!-- VIEW MODE -->
            <div v-else class="text-muted">
                <span v-if="user?.functions?.length" v-for="(func, i) in user.functions" :key="i">
                    <span v-if="i">, </span>
                    {{ $t("functions." + func.name) }}
                </span>
                <span v-else>-</span>
            </div>
        </div>
        <!-- ACTIONS -->
        <div class="d-flex gap-2 mt-4">
            <button class="btn btn-outline-primary" @click="editable = !editable">
                {{ editable ? $t("utils.cancel") : $t("utils.edit") }}
            </button>
            <button v-if="editable" class="btn btn-primary text-white" @click="save()">
                {{ $t("utils.save") }}
            </button>
        </div>
    </div>
</template>


<script>
import EditableRow from "@/components/EditableRow.vue";

export default {
    components: {
        EditableRow
    },
    data() {
        return {
            editable: false,
            user: {},
            functions: [],
            userId: null
        }
    },
    created: function () {
        this.userId = this.$route.params.id;
        this.loadData();
    },
    methods: {
        loadData: function (functions) {
            this.$store.getters.api.get("/user/" + this.userId).then((response) => {
                this.user = response.data.item;
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
                var status = response?.response?.status;
                if (status == 404) {
                    this.$router.push({ "name": "users" });
                }
            });
            this.$store.getters.api.get("/functions").then((response) => {
                this.functions = response.data.items
            });
        },
        save: function () {
            this.$store.getters.api.put("/user/" + this.userId + "/edit", this.user).then((response) => {
                this.user = response.data.item;
                this.editable = false;
                this.loadData();
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
            });
        }
    }
}
</script>

<style lang="scss"></style>